import { AppState } from 'redux/reducers';

export const getLoggedInStatusState = ({ auth }: AppState) => auth.isLoggedIn;
export const getLoggedInLoading = ({ auth }: AppState) => auth.loading;
export const getLogoutRedirectUrl = ({ auth }: AppState) => auth.logoutRedirectUrl;
export const getIsAuthError = ({ auth }: AppState) => !!auth.error;
export const getAuthErrorMessage = ({ auth }: AppState) => auth.error?.message;
export const getAuthIsVerified = ({ auth }: AppState) => auth.isVerified;
